import { isPresent, noop } from 'utils'
import Loading from 'components/loading/Loading'
import classNames from 'classnames'
import PropTypes from 'prop-types'

let i = 0

const Switch = ({
  disabled = false,
  isLoading = false,
  status,
  onChange = noop,
}) => {
  const id = i++
  return !isPresent(status) || isLoading ? (
    <Loading size="icon" />
  ) : (
    <span
      className={classNames('switch_check', {
        on: status === 'ON',
        in_active: disabled,
      })}>
      <input
        type="checkbox"
        id={`inpSwitch${id}`}
        className="inp_check"
        checked={status === 'ON'}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={`inpSwitch${id}`} className="lab_check">
        <span className="ico_switch">{disabled ? '운영중지' : '운영중'}</span>
      </label>
    </span>
  )
}
Switch.propTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  status: PropTypes.string,
}
export default Switch
